import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/index.css'
import 'react-datepicker/dist/react-datepicker.css'
import ErrorBoundary from './components/Common/ErrorBoundary'
// Initialize i18n
import './i18n'
import * as Sentry from '@sentry/react'

// GDPR: Analytics are initialized ONLY in CookieBanner after user consent
// Do NOT initialize analytics here!
console.log('[GDPR] App starting - analytics will only load after user consent')

// Sentry error tracking (no-op unless VITE_SENTRY_DSN is set)
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_COMMIT_SHORT || undefined,
    sendDefaultPii: false,
    tracesSampleRate: 0,
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <React.Suspense fallback={
        <div className="flex items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        </div>
      }>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.Suspense>
    </ErrorBoundary>
  </React.StrictMode>,
)